import { AppState, ThunkDispatch } from "redux/store.types";
import { fetchTicketCategories } from "services/service/ticket/ticket.service";
import { TicketEntity } from "../../../types/service.types";

export const RESET_SERVICE = "RESET_SERVICE";
export const SET_CATEGORIES_SUBCATEGORIES = "SET_CATEGORIES_SUBCATEGORIES";
export const SET_CATEGORIES_SELECTED = "SET_CATEGORIES_SELECTED";
export const SET_NOTE_IS_PUBLIC = "SET_NOTE_IS_PUBLIC";
export const SET_TICKET_ENTITY_DATA = "SET_TICKET_ENTITY_DATA";
export const SET_REQUESTER = "SET_REQUESTER";

export const resetService = () => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  return dispatch({ type: RESET_SERVICE });
};

export const setCategoriesSubcategories = () => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const categories = await fetchTicketCategories();
  if (!categories) {
    return;
  }
  dispatch({ type: SET_CATEGORIES_SUBCATEGORIES, payload: categories });
};

export const setCategoriesSelected = (categoriesSelected: string[]) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_CATEGORIES_SELECTED, payload: categoriesSelected });
};

export const setTicketEntityData = (entityData: TicketEntity) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_TICKET_ENTITY_DATA, payload: entityData });
};

export const setNoteIsPublic = (status: boolean) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_NOTE_IS_PUBLIC, payload: status });
};

export const setRequester = (requester: any) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  if (!requester) {
    return;
  }
  const { documentType, document, uid } = requester;
  if (documentType && document) {
    requester.documentId = document;
  }
  if (uid) {
    requester.externalId = uid;
  }
  dispatch({ type: SET_REQUESTER, payload: requester });
};
